import Default from "@/Layouts/Default";
import { Head } from "@inertiajs/inertia-react";
import React from "react";
import ValidationErrors from "@/Components/ValidationErrors";
import Notification from "@/Components/Notification";
import { useForm } from "@inertiajs/inertia-react";
import axios from "axios";
import { Inertia } from '@inertiajs/inertia';

export default function CancelPage() {
    const { data, setData, post, processing, errors, reset } = useForm({
        name: "",
        email: "",
        reason: "",
    });

    const onHandleChange = (event) => {
        setData(event.target.name, event.target.value);
    };

    const submit = (e) => {
        e.preventDefault();

        axios.post("/opzeggen/bevestigen", data).then((response) => {
            console.log(response);
            
            setData({
                name: "",
                email: "",
                reason: "",
            });

            Inertia.visit(route("cancel.confirmed"));
        }).catch((error) => {
            console.log(error);
        });
    };

    return (
        <Default>
            <Head>
                <title>
                    Opzeggen - WE ARE Personal Training Uden en Schijndel
                </title>
                <link rel="canonical" href={route("cancel")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="Opzeggen - WE ARE Personal Training Uden en Schijndel"
                />
                <meta
                    property="og:description"
                    content="Opzeggen - WE ARE Personal Training Uden en Schijndel"
                />
                <meta property="og:url" content={route("cancel")} />
                <meta property="og:type" content="website" />
                <meta
                    property="og:title"
                    content="Opzeggen - WE ARE Personal Training Uden en Schijndel"
                />
                <meta
                    property="og:image"
                    content="/assets/personal-training-uden-schijndel.png"
                />
            </Head>

            <div className="bg-black">
                {/* <Hero homepage={false} header={"Opzeggen"}></Hero> */}

                <div
                    className="relative pb-24 pt-4 bg-sky-800 sm:pb-32"
                    id="contact"
                >
                    <div className="absolute inset-0">
                        <picture>
                            <source
                                srcSet="/assets/webp/personal-training-schijndel-uden.webp"
                                type="image/webp"
                                alt="Personal training locatie Schijndel en Uden"
                                className="w-full h-full object-cover"
                            />
                            <source
                                srcSet="/assets/personal-training-schijndel-uden.jpg"
                                type="image/jpeg"
                                alt="Personal training locatie Schijndel en Uden"
                                className="w-full h-full object-cover"
                            />
                            <img
                                src="/assets/personal-training-schijndel-uden.jpg"
                                alt="Personal training locatie Schijndel en Uden"
                                className="w-full h-full object-cover"
                            />
                        </picture>
                    </div>
                    <div className="relative mt-12 max-w-md mx-auto px-4 sm:max-w-3xl sm:mt-32 sm:px-6 lg:max-w-7xl lg:px-8">
                        <h2 className="block text-white mx-auto font-custom italic font-bold uppercase max-w-4xl xs:text-4xl sm:text-4xl md:text-4xl lg:text-5xl mt-8">
                            Opzeggen
                        </h2>

                        <ValidationErrors errors={errors} />
                        <Notification />

                        <form
                            onSubmit={submit}
                            method="POST"
                            className="mt-6 grid grid-cols-1 gap-y-6 sm:grid-cols-2 sm:gap-x-8"
                        >
                            <div>
                                <label
                                    htmlFor="name"
                                    className="block text-sm font-medium text-gray-100"
                                >
                                    Volledige naam
                                </label>
                                <div className="mt-1">
                                    <input
                                        onChange={onHandleChange}
                                        required
                                        value={data.name}
                                        type="text"
                                        name="name"
                                        id="name"
                                        autoComplete="given-name"
                                        className="bg-black border-none py-3 px-4 block w-full shadow-sm text-gray-100 focus:ring-we-are-purple focus:border-we-are-purple rounded-md"
                                    />
                                </div>
                            </div>
                            <div>
                                <label
                                    htmlFor="email"
                                    className="block text-sm font-medium text-gray-100"
                                >
                                    E-mailadres
                                </label>
                                <div className="mt-1">
                                    <input
                                        onChange={onHandleChange}
                                        required
                                        value={data.email}
                                        id="email"
                                        name="email"
                                        type="email"
                                        autoComplete="email"
                                        className="bg-black border-none py-3 px-4 block w-full shadow-sm text-gray-100 focus:ring-we-are-purple focus:border-we-are-purple rounded-md"
                                    />
                                </div>
                            </div>
                            <div className="sm:col-span-2">
                                <div className="flex justify-between">
                                    <label
                                        htmlFor="reason"
                                        className="block text-sm font-medium text-gray-100"
                                    >
                                        Vertel ons waarom je wilt opzeggen
                                    </label>
                                </div>
                                <div className="mt-1">
                                    <textarea
                                        onChange={onHandleChange}
                                        required
                                        value={data.reason}
                                        id="reason"
                                        name="reason"
                                        rows={4}
                                        className="bg-black border-none py-3 px-4 block w-full shadow-sm text-gray-100 focus:ring-we-are-purple focus:border-we-are-purple border rounded-md"
                                        aria-describedby="message-max"
                                    />
                                </div>
                            </div>
                            <div className="sm:col-span-2 sm:flex sm:justify-end">
                                <button
                                    type="submit"
                                    className="mt-2 w-full inline-flex items-center justify-center px-6 py-3 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-we-are-purple focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-we-are-purple sm:w-auto"
                                >
                                    Bevestig je opzegging
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
                {/* <Contact /> */}
            </div>
        </Default>
    );
}
